/***
*
*   API Keys List
*   List & manage the API keys
*
**********/

import React, { Fragment, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { ViewContext, Animate, Button, Card, Table, 
  BlankSlateMessage, Loader, History, useAPI } from 'components/lib';
import { useParams } from 'react-router-dom';
import AccountNav from '../nav';
export function APIKeyList(props){

  const context = useContext(ViewContext);
  const { id: accountId } = useParams();
  const fetch = useAPI(`/api/account/${accountId}/key`);
  const [keys, setKeys] = useState([]);
  const [accountType, setAccountType] = useState(null);
  const [accountLoading, setAccountLoading] = useState(true);

  const checkAccountType = useCallback(async () => {
    try {
      // Get account information to check monitoring level
      const response = await axios.get('/api/user/associatedDataConnections');
      const accounts = response.data.data;
      const currentAccount = accounts.find(acc => acc.id === accountId);
      
      if (currentAccount) {
        setAccountType(currentAccount.account_type || 'health_score_only');
      }
      setAccountLoading(false);
    } catch (error) {
      console.error('Error fetching account info:', error);
      setAccountLoading(false);
    }
  }, [accountId]);

  useEffect(() => {
    checkAccountType();
  }, [accountId, checkAccountType]);

  useEffect(() => {
    if (fetch?.data?.length)
      setKeys(fetch.data);
  }, [fetch]);

  function revoke(data){
    context.modal.show({
      title: 'Revoke API Key ',
      form: {
        active: {
          type: 'hidden',
          value: false,
        }
      },
      text: 'Are you sure you want to revoke this API Key? This action cannot be undone.',
      buttonText: 'Revoke API Key',
      url: `/api/account/${accountId}/key/${data.id}`,
      destructive: true,
      method: 'PATCH',

      }, () => {

        const state = [...keys];
        state.find(x => x.id === data.id).active = false;
        setKeys(state);

    });
  }

  function del(data){
    context.modal.show({
      title: 'Delete API Key ',
      form: {},
      text: 'Are you sure you want to delete this API Key? This action cannot be undone.',
      buttonText: 'Delete API Key',
      url: `/api/account/${accountId}/key/${data.id}`,
      destructive: true,
      method: 'DELETE',

      }, () => {

        const state = [...keys];
        state.splice(state.findIndex(x => x.id === data.id), 1);
        setKeys(state);

    });
  }

  async function reveal(data){

    // reveal the api key
    const key = (await axios.get(`/api/account/${accountId}/key/${data.id}`))?.data?.data?.[0].key;
    const state = [...keys];
    state[state.findIndex(x => x.id === data.id)].key = key;
    setKeys(state);

  }
    
  // Redirect health score only accounts
  if (!accountLoading && accountType === 'health_score_only') {
    History.push(`/account/${accountId}`);
    return null;
  }

  return (
    <Fragment>

      <AccountNav/>

      { (fetch.loading || accountLoading) ? 
        <Loader /> :
        <Fragment>

          { keys?.length ?
            <Animate>

            <section className='title-row'>
              <h2>Your API Keys</h2>
              <Button small text='Generate New API Key' goto={`/account/${accountId}/apikeys/create`} />
            </section>

            <Card>
              <Table 
                data={ keys } 
                loading={ fetch.loading }
                show={['name', 'key', 'active']}
                actions={{ 
                  custom: [

                    { icon: 'eye', action: reveal },
                    { icon: 'rotate-ccw', action: revoke, condition: { col: 'active', value: true }}],

                  edit: (data) => { History.push(`/account/${accountId}/apikeys/edit?id=${data.id}`) },
                  delete: del,
              }}
                badge={{ col: 'active', color: 'green', condition: [

                  { value: true, color: 'green' },
                  { value: false, color: 'red' }
                
                ]}}
              />
            </Card> 
          </Animate> :

          <BlankSlateMessage 
            title='Create an API Key'
            text={`You haven't created any API keys yet. Would you like to create one now?`}
            buttonText='Create API Key'
            action={ () => History.push(`/account/${accountId}/apikeys/create`) }
            marginTop='4em'
          />
          
          }
        </Fragment>
      }
    </Fragment>
  );
}
